

















import { IconSize } from '@getaccept/lib-ui';
import type { SigningPageUser } from '@getaccept/lib-shared/src/types/signing-page-user';
import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import HandEmoji from '../assets/hand-emoji.svg';

export default defineComponent({
  components: {
    HandEmoji,
  },
  props: {
    sender: {
      type: Object as PropType<SigningPageUser>,
      required: true,
    },
  },
  setup(_, { emit }) {
    const handleClose = () => {
      emit('close');
    };

    const handleClick = () => {
      emit('click');
    };

    return {
      IconSize,
      handleClose,
      handleClick,
    };
  },
});
